import { render, staticRenderFns } from "./selectDealerExpenseDetail.vue?vue&type=template&id=c0edccc4&scoped=true&"
import script from "./selectDealerExpenseDetail.vue?vue&type=script&lang=js&"
export * from "./selectDealerExpenseDetail.vue?vue&type=script&lang=js&"
import style0 from "./selectDealerExpenseDetail.vue?vue&type=style&index=0&id=c0edccc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0edccc4",
  null
  
)

export default component.exports